import { ShipmentStatus } from './types';

export const SHIPMENT_DOCUMENT_MAX_BYTES = 10 * 1024 * 1024;

export const SHIPMENT_DOCUMENT_TITLE_PRESETS = [
  'Transport label',
  'Waybill and proforma',
  'Statement letter',
  'Customs document',
  'UN1845 dry ice label',
  'Dry ice instructions',
  'Other',
] as const;

const CUSTOMER_VISIBLE_SHIPMENT_DOCUMENT_STATUSES = new Set<ShipmentStatus>([
  ShipmentStatus.SCHEDULED,
  ShipmentStatus.PROCESSED,
  ShipmentStatus.PICKED_UP,
  ShipmentStatus.RECEIVED,
]);

export function isShipmentDocumentCustomerVisibleStatus(status: ShipmentStatus): boolean {
  return CUSTOMER_VISIBLE_SHIPMENT_DOCUMENT_STATUSES.has(status);
}

type ShipmentDocumentEmailDraftInput = {
  id: number;
  contactName: string;
  pickupDate: string;
  pickupWindowStart: string;
  pickupWindowEnd: string;
  confirmationUrl: string | null;
  documents: Array<{ title: string }>;
  documentCentreUrl: string;
};

export type ShipmentDocumentEmailDraft = {
  subject: string;
  body: string;
};

export function buildShipmentDocumentEmailDraft(shipment: ShipmentDocumentEmailDraftInput): ShipmentDocumentEmailDraft {
  const confirmationUrl = shipment.confirmationUrl ?? '[Add third-party pickup confirmation link]';
  const documentList =
    shipment.documents.length > 0
      ? `\n\nDocuments currently available:\n${shipment.documents.map(document => `- ${document.title}`).join('\n')}`
      : '';

  return {
    subject: `Shipment #${shipment.id} pickup confirmation and documents`,
    body: `Hi ${shipment.contactName},

Your pickup for shipment #${shipment.id} is scheduled for ${shipment.pickupDate}, between ${shipment.pickupWindowStart} and ${shipment.pickupWindowEnd}.

Please confirm the pickup with the transport provider using this link:
${confirmationUrl}

Your shipping documents are available securely in the Resistomap Platform:
${shipment.documentCentreUrl}${documentList}

Please download and follow the documents required for your shipment. If you have any questions, reply to your existing Resistomap contact.

Best regards,
The Resistomap Team`,
  };
}
